<template>
<form @submit="submit($event)">
  <CityBackgroundImage>
    <v-layout align-center justify-center row fill-height class="login-page">
      <v-flex xs12 sm8 md6 lg5 xl4>
        <v-card color="transparent" class="elevation-0">
          <v-responsive>
            <img class="asu-logo" src="@/assets/img/asuparticipax2.png" alt="People" />
          </v-responsive>

          <v-card-title style="justify-content: center;">
            <div class="login-title">AsuParticipa para AsuCostera</div>
          </v-card-title>

          <v-card-text>

            <v-text-field
              dark
              required
              clearable
              color="white"
              prepend-icon="person"
              label="Nombre de usuario"
              v-model="form.username"
              :disabled="sending"
              :error-messages="getMessageErrors('form.username')"
              @input="$v.form.username.$touch()"
              @blur="$v.form.username.$touch()"
            ></v-text-field>

            <v-text-field
              dark
              required
              clearable
              color="white"
              type="password"
              prepend-icon="lock"
              label="Contraseña"
              v-model="form.password"
              :disabled="sending"
              :error-messages="getMessageErrors('form.password')"
              @input="$v.form.password.$touch()"
              @blur="$v.form.password.$touch()"
            ></v-text-field>

            <v-btn class="login-btn" type="submit" :disabled="sending">Ingresar</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <ErrorDialog
      :showErrorDialog="errorDialog"
      :errorDialogMessage="errorDialogMessage"
      @confirm-dialog="errorDialog = false"
      @close-dialog="errorDialog = false">
    </ErrorDialog>
  </CityBackgroundImage>
</form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { required } from 'vuelidate/lib/validators'
import validationUtilsMixin from '@/mixins/validation-utils.js'
import errorDialogMixin from '@/mixins/dialog-for-server-error.js'
import RedmineService from '@/services/redmine-gateway.js'

export default {
  name: 'Login',
  mixins: [ validationUtilsMixin, errorDialogMixin ],
  validations: {
    form: {
      username: {
        required
      },
      password: {
        required
      }
    }
  },
  data: () => ({
    form: {
      username: '',
      password: ''
    }
  }),
  methods: {
    ...mapActions(['login', 'errorLogin']),
    submit (event) {
      event.preventDefault()
      if (this.isValid()) {
        const username = this.form.username
        RedmineService
          .signInWithEmailAndPassword(this.$http, username, this.form.password)
          .then(({ user }) => {
            this.login(user)
            this.$router.push({ name: 'listProject' })
          })
          .catch(err => {
            if (/401/.test(err.bodyText)) return this.showErrorMessage('Usuario y contraseña inválidos', () => this.errorLogin('Ocurrió un error al intentar loguearse'))
            this.showErrorMessage(err, () => this.errorLogin('Ocurrió un error al intentar loguearse'))
          })
      }
    },
    isValid () {
      this.$v.$touch()
      return !this.$v.$invalid
    }
  },
  computed: {
    ...mapGetters({
      'sending': 'httpIsProcessing',
      'isLogged': 'isLogged'
    })
  },
  watch: {
    isLogged (logged) {
      if (logged) {
        this.$router.push({ name: 'listProject' })
      }
    }
  }
}
</script>
<style scoped lang="stylus">
@import '~@/styles/variables'

$login-btn-height = $f37px

.login-page
  height: 100vmin
  height: 100vh
  text-align: center

.login-title
  color: white
  font-size: $f35px
  font-weight: bold

.login-btn
  background-color: white
  border: 0
  border-radius: $login-btn-height
  color: $color_0
  height: $login-btn-height
  font-size: $f20px
  font-weight: bold
  padding: $f6px 0
  text-transform: uppercase
  text-align: center
  width: $f200px

.asu-logo
  width: $f250px

</style>
<style lang="stylus">
// INICIO - Estilos para login transtparente
.login-page
  & input:focus
    background-position: 0 0
  & input:-internal-autofill-previewed,
  & input:-internal-autofill-previewed:hover,
  & input:-internal-autofill-previewed:focus,
  & input:-internal-autofill-selected,
  & input:-internal-autofill-selected:hover,
  & input:-internal-autofill-selected:focus,
  & input:-webkit-autofill,
  & input:-webkit-autofill:hover,
  & input:-webkit-autofill:focus
    background-color: transparent !important
  & input:-internal-autofill-previewed + i.material-icons svg,
  & input:-internal-autofill-selected + i.material-icons svg
    fill: black
  & i.material-icons svg
    fill: white
// FIN - Estilos para login transtparente
</style>
